/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Tax_AcceptedInputs */

const vi_einvoice_tax_accepted = /** @type {(inputs: Einvoice_Tax_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cơ quan thuế đã tiếp nhận dữ liệu`)
};

/**

* @param {Einvoice_Tax_AcceptedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_tax_accepted = /** @type {((inputs?: Einvoice_Tax_AcceptedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Tax_AcceptedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_tax_accepted(inputs)
});